import { useState } from "react";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { Loader2, Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function StripePaymentForm({ totalDisplay }) {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setSubmitting(true);
    setErrorMsg("");
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/success`,
      },
    });
    if (error) {
      const msg = error.message || "Payment failed. Please try again.";
      setErrorMsg(msg);
      toast.error(msg);
      setSubmitting(false);
    }
    // On success Stripe redirects to /success?payment_intent=...
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white border border-black/10 p-6 sm:p-8" data-testid="stripe-payment-form">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display font-bold text-2xl tracking-tight">Payment</h2>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#525252]">
          <Lock className="w-3 h-3" /> Secured by Stripe
        </div>
      </div>

      <PaymentElement
        options={{
          layout: { type: "tabs", defaultCollapsed: false },
          fields: {
            billingDetails: {
              email: "auto",
              name: "auto",
              phone: "auto",
              address: "auto",
            },
          },
          wallets: {
            applePay: "auto",
            googlePay: "auto",
          },
        }}
      />

      {errorMsg && (
        <div className="mt-4 text-sm text-[#D92D20]" data-testid="stripe-error">
          {errorMsg}
        </div>
      )}

      <button
        type="submit"
        disabled={!stripe || submitting}
        className="mt-7 w-full inline-flex items-center justify-center gap-3 bg-[#D92D20] text-white px-8 py-4 text-base font-medium hover:bg-[#B42318] transition-colors disabled:opacity-60"
        data-testid="pay-now-btn"
      >
        {submitting ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-5 h-5" />}
        Pay {totalDisplay}
        <ArrowRight className="w-5 h-5" />
      </button>

      <p className="mt-3 text-[10px] uppercase tracking-[0.2em] text-[#737373]">
        Apple Pay · Google Pay · Card · Link
      </p>
    </form>
  );
}
